// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"src-components-tables-ImportedClaims-controls-DeleteBooking-styles__deleteButton"};